module.exports = __webpack_public_path__ + "static/media/calSelected.c28155a1.svg";